export const config = {
  url: "https://souq-abnoud.vercel.app/",
  // url:"https://souq-abnod.herokuapp.com/",
  // url:"https://souq-abnoud.onrender.com/",
};
